import { useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { PageTitle } from '../../../_metronic/layout/core';
import BackButton from '../../components/BackButton/BackButton';
import { useAuth } from '../../modules/auth';
import styleScss from './styles.module.scss';
import {
	getAllUserCurriculoFormatted,
	getEventoEmpleabilidadById,
	getLocalidades,
	getTiposPoblacionPriorizadaEventoEmpleabilidad,
	getVacantesInformacionEvento,
	prerregistrarCandidatoEvento,

} from '../../modules/apps/user-management/users-list/core/_requests';
import { formatNumber } from '../../util/Index';
import { LoadingBackdrop } from '../../components/LoadingSpinner/LoadingSpinner';
import {
	Autocomplete,
	Alert,
	AlertTitle,
	Button,
	CircularProgress,
	FormControl,
	Grid,
	InputLabel,
	MenuItem,
	Paper,
	Select,
	Snackbar,
	Stack,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	TextField,
	Typography,
} from '@mui/material';
import parameterSingleton from '../../services/Parameters.service';
import parameters from '../../util/parameters';
import { ParameterConfigMmodel } from '../../models/parameter.model';
import {
	Localidad,
	ParametroEventoEmpleabilidad,
	EventoEmpleabilidad,
	formatDateDisplay,
	getErrorMessage,
	parseTipoPoblacionPriorizada,
} from './EventosEmpleabilidad.helpers';
import { CandidatePreRegisterModel } from '../../modules/apps/user-management/users-list/core/_models';

interface VacanteEvento {
	id: number;
	codigo_vacante: string;
	nombre_vacante: string;
	nivel_estudio: string;
	rango_experiencia: string;
	modalidad_trabajo: string;
	salario: string;
	tipo_contrato: string;
}


const InfoField = ({ label, value }: { label: string; value: React.ReactNode }) => (
	<div style={{ display: 'flex', borderRadius: 6, overflow: 'hidden', marginBottom: 10 }}>
		<div style={{ background: '#4683DE', color: '#FFFFFF', fontSize: 13, fontWeight: 600, padding: '9px 12px', fontFamily: 'Poppins', flex: '0 0 45%', display: 'flex', alignItems: 'center' }}>
			{label}
		</div>
		<div style={{ background: '#F3F6F9', color: '#000000', fontSize: 14, padding: '9px 12px', fontFamily: 'Poppins', flex: '1 1 55%', display: 'flex', alignItems: 'center' }}>
		    {value === '' || value === null || value === undefined ? ' ' : value}
		</div>
	</div>
);

const FillerField = () => (
	<div style={{ borderRadius: 6, overflow: 'hidden', marginBottom: 10, background: '#F3F6F9', minHeight: 38 }} />
);

const EventoInformacionPage = () => {
	const navigate = useNavigate();
	const { id: eventoId } = useParams();
	const { isAdminRole, isCandidateRole, isEmployerRole } = useAuth();
	const location = useLocation();
	const isReadOnly = (location.state as { readOnly?: boolean })?.readOnly ?? false;

	const EVENTOS_LIST_PATH = isAdminRole()
		? '/admin/gestion-eventos'
		: isCandidateRole()
		? '/candidato/gestion-eventos'
		: isEmployerRole()
		? '/empleador/gestion-eventos'
		: '/consejero/gestion-eventos';

	const [evento, setEvento] = useState<EventoEmpleabilidad | null>(null);
	const [localidades, setLocalidades] = useState<Localidad[]>([]);
	const [tiposPoblacionPriorizada, setTiposPoblacionPriorizada] = useState<ParametroEventoEmpleabilidad[]>([]);

	const [selectedFranja, setSelectedFranja] = useState<string>('');
	const [loadingPrerregistro, setLoadingPrerregistro] = useState(false);
	const [franjasHorarias, setFranjasHorarias] = useState<ParameterConfigMmodel[]>([]);
	const [candidates, setCandidates] = useState<CandidatePreRegisterModel[]>([]);
	const [loadingCandidates, setLoadingCandidates] = useState<boolean>(false);
	const [selectedCandidate, setSelectedCandidate] = useState<CandidatePreRegisterModel | null>(null);

	const [formData, setFormData] = useState({
		tipo_doc: '',
		numero_doc: '',
		primer_nome: '',
		segundo_nome: '',
		primer_apelido: '',
		segundo_apelido: '',
	});

	useEffect(() => {
		if (isAdminRole()) {
			setLoadingCandidates(true);
			getAllUserCurriculoFormatted()
				.then((data) => setCandidates(data))
				.catch((err) => console.error('Error cargando candidatos:', err))
				.finally(() => setLoadingCandidates(false));
		}
	}, [isAdminRole]);

	const handleSelectCandidate = (event: any, candidate: CandidatePreRegisterModel | null) => {
		setSelectedCandidate(candidate);
		if (candidate) {
			setFormData({
				tipo_doc: candidate.tipo_doc,
				numero_doc: candidate.numero_doc,
				primer_nome: candidate.primer_nome,
				segundo_nome: candidate.segundo_nome || '',
				primer_apelido: candidate.primer_apelido,
				segundo_apelido: candidate.segundo_apelido || '',
			});
		} else {
			setFormData({
				tipo_doc: '',
				numero_doc: '',
				primer_nome: '',
				segundo_nome: '',
				primer_apelido: '',
				segundo_apelido: '',
			});
		}
	};

	const [nivelesEstudio, setNivelesEstudio] = useState<ParameterConfigMmodel[]>([]);
	const [modalidadesTrabajo, setModalidadesTrabajo] = useState<ParameterConfigMmodel[]>([]);
	const [tiposContrato, setTiposContrato] = useState<ParameterConfigMmodel[]>([]);
	const [rangosSalariales, setRangosSalariales] = useState<ParameterConfigMmodel[]>([]);

	const [codigoVacante, setCodigoVacante] = useState('');
	const [nombreVacante, setNombreVacante] = useState('');
	const [nivelEstudioFiltro, setNivelEstudioFiltro] = useState('');
	const [modalidadTrabajoFiltro, setModalidadTrabajoFiltro] = useState('');
	const [tipoContratoFiltro, setTipoContratoFiltro] = useState('');
	const [salarioDesdeFiltro, setSalarioDesdeFiltro] = useState('');
	const [salarioHastaFiltro, setSalarioHastaFiltro] = useState('');
	const [experienciaFiltro, setExperienciaFiltro] = useState('');

	const [vacantes, setVacantes] = useState<VacanteEvento[]>([]);
	const [buscadoVacantes, setBuscadoVacantes] = useState(false);
	const [loadingVacantes, setLoadingVacantes] = useState(false);

	const [loading, setLoading] = useState(false);

	const [open, setOpen] = useState(false);
	const [alert, setAlert] = useState(true);
	const [alertMsg, setAlertMsg] = useState('');

	const notify = (msg: string, success = true) => {
		setAlert(success);
		setAlertMsg(msg);
		setOpen(true);
		setTimeout(() => setOpen(false), 3000);
	};

	useEffect(() => {
		if (!eventoId) {
			navigate(EVENTOS_LIST_PATH);
			return;
		}
		setLoading(true);
		getEventoEmpleabilidadById(Number(eventoId))
			.then((response: any) => {
				const data = response?.data || response;
				if (data) setEvento(data);
			})
			.catch((error: any) => {
				notify(getErrorMessage(error), false);
			})
			.finally(() => setLoading(false));
	}, [eventoId]);

	useEffect(() => {
		getLocalidades()
			.then((response: any) => {
				if (response && response.data) setLocalidades(response.data);
			})
			.catch(() => {});
	}, []);

	useEffect(() => {
		getTiposPoblacionPriorizadaEventoEmpleabilidad()
			.then((response: any) => {
				if (response && response.data) setTiposPoblacionPriorizada(response.data);
			})
			.catch(() => {});
	}, []);

	useEffect(() => {
		parameterSingleton.fetchData(parameters.NIVELEDUCATIVO).then(setNivelesEstudio).catch(() => {});
		parameterSingleton.fetchData(parameters.PRESENCIALIDAD).then(setModalidadesTrabajo).catch(() => {});
		parameterSingleton.fetchData(parameters.TIPOCONTRATO).then(setTiposContrato).catch(() => {});
		parameterSingleton.fetchData(parameters.SALARIOMENSUAL).then(setRangosSalariales).catch(() => {});
 
		parameterSingleton.fetchData(parameters.FRANJA_HORARIA)
        .then((data) => {            
            const lista = Array.isArray(data) ? data : (data as any)?.data || [];            
            setFranjasHorarias(lista);
        })
        .catch((err) => console.error('Error al cargar franjas horarias:', err));
	}, []);


	useEffect(() => {
		
	}, [evento]);

	
	const handlePrerregistrar = async () => {
		if (!eventoId || !selectedFranja) {
			notify('Por favor seleccione una franja horaria.', false);
			return;
		}

		if (isAdminRole() && !selectedCandidate) {
			notify('Por favor seleccione un candidato de la lista.', false);
			return;
		}

		setLoadingPrerregistro(true);
		try {
			const payloadFranja = Number(selectedFranja);
			
			const payload: Record<string, any> = {
				id_franja_horaria: payloadFranja,
				franja_horaria_id: payloadFranja,
				idFranjaHoraria: payloadFranja,
			};

			if (isAdminRole() && selectedCandidate) {
				payload.tipo_doc = selectedCandidate.tipo_doc;
				payload.numero_doc = selectedCandidate.numero_doc;
				payload.tipo_documento = selectedCandidate.tipo_doc; 
				payload.numero_documento = selectedCandidate.numero_doc;
				
				if ((selectedCandidate as any).id) {
					payload.user_id = (selectedCandidate as any).id;
					payload.id_usuario = (selectedCandidate as any).id;
				}
			}

			await prerregistrarCandidatoEvento(Number(eventoId), payload);
			notify('¡Prerregistro realizado con éxito!', true);
			
			setSelectedCandidate(null);
			setSelectedFranja('');
			setFormData({
				tipo_doc: '',
				numero_doc: '',
				primer_nome: '',
				segundo_nome: '',
				primer_apelido: '',
				segundo_apelido: '',
			});

			const response = await getEventoEmpleabilidadById(Number(eventoId));
			const data = response?.data || response;
			if (data) setEvento(data);
		} catch (error: any) {
			notify(getErrorMessage(error), false);
		} finally {
			setLoadingPrerregistro(false);
		}
	};

	const formatSalario = (salarioMensual: string): string => {
		if (!salarioMensual || salarioMensual === '-1') return 'A Convenir';
		const rango = rangosSalariales.find((item) => item.code === salarioMensual);
		return formatNumber(rango?.value ?? salarioMensual);
	};

	const formatRangoSalario = (salarioMensual: string, salarioMensualMax?: string): string => {
		const minimo = formatSalario(salarioMensual);
		if (!salarioMensual || salarioMensual === '-1' || !salarioMensualMax || salarioMensualMax === salarioMensual) return minimo;
		return `${minimo} - ${formatSalario(salarioMensualMax)}`;
	};

	const rangosSalarialesFiltrables = rangosSalariales
		.filter((item) => item.code !== '-1')
		.sort((a, b) => Number(a.value) - Number(b.value));

	const salarioMenuProps = {
		anchorOrigin: { vertical: 'bottom' as const, horizontal: 'left' as const },
		transformOrigin: { vertical: 'top' as const, horizontal: 'left' as const },
		PaperProps: { style: { maxHeight: 300 } },
	};

	const fetchVacantes = (filtros?: {
		codigo_vacante?: string;
		nombre_vacante?: string;
		nivel_estudio?: string;
		modalidad_trabajo?: string;
		tipo_contrato?: string;
		salario_desde?: string;
		salario_hasta?: string;
		rango_experiencia?: string;
	}) => {
		if (!eventoId) return;
		setLoadingVacantes(true);
		setBuscadoVacantes(true);
		getVacantesInformacionEvento(Number(eventoId), {
			codigo_vacante: filtros?.codigo_vacante || undefined,
			nombre_vacante: filtros?.nombre_vacante || undefined,
			nivel_estudio: filtros?.nivel_estudio || undefined,
			modalidad_trabajo: filtros?.modalidad_trabajo || undefined,
			tipo_contrato: filtros?.tipo_contrato || undefined,
			salario_desde: filtros?.salario_desde || undefined,
			salario_hasta: filtros?.salario_hasta || undefined,
			rango_experiencia: filtros?.rango_experiencia || undefined,
		})
			.then((response: any) => {
				const data = response?.data || response || [];
				const mapeadas: VacanteEvento[] = (Array.isArray(data) ? data : []).map((vacante: any) => ({
					id: vacante.id,
					codigo_vacante: vacante.codigo_vacante || '',
					nombre_vacante: vacante.nombre_vacante || '',
					nivel_estudio: vacante.nivel_estudio || '',
					rango_experiencia: vacante.rango_experiencia || '',
					modalidad_trabajo: vacante.modalidad_trabajo || '',
					salario: formatRangoSalario(vacante.salario_mensual, vacante.salario_mensual_max),
					tipo_contrato: vacante.tipo_contrato || '',
				}));
				setVacantes(mapeadas);
			})
			.catch((error: any) => {
				notify(getErrorMessage(error), false);
				setVacantes([]);
			})
			.finally(() => setLoadingVacantes(false));
	};

	useEffect(() => {
		if (!eventoId) return;
		fetchVacantes();
	}, [eventoId]);

	const handleBuscarVacantes = () => {
		if (salarioDesdeFiltro && salarioHastaFiltro && Number(salarioDesdeFiltro) > Number(salarioHastaFiltro)) {
			notify('El salario "desde" no puede ser mayor que el salario "hasta".', false);
			return;
		}
		fetchVacantes({
			codigo_vacante: codigoVacante,
			nombre_vacante: nombreVacante,
			nivel_estudio: nivelEstudioFiltro,
			modalidad_trabajo: modalidadTrabajoFiltro,
			tipo_contrato: tipoContratoFiltro,
			salario_desde: salarioDesdeFiltro,
			salario_hasta: salarioHastaFiltro,
			rango_experiencia: experienciaFiltro,
		});
	};

	const handleLimpiarFiltrosVacantes = () => {
		setCodigoVacante('');
		setNombreVacante('');
		setNivelEstudioFiltro('');
		setModalidadTrabajoFiltro('');
		setTipoContratoFiltro('');
		setSalarioDesdeFiltro('');
		setSalarioHastaFiltro('');
		setExperienciaFiltro('');
		fetchVacantes();
	};

	const getLocalidadLabel = (): string => {
		if (!evento) return '';
		if (evento.Localidad?.desc_localidad) return evento.Localidad.desc_localidad;
		const localidad = localidades.find((l) => l.id_localidad === evento.localidad_id);
		return localidad?.desc_localidad || '';
	};

	const getTipoPoblacionLabel = (): string => {
		if (!evento) return '';
		const valores = parseTipoPoblacionPriorizada(evento.tipo_poblacion_priorizada);
		if (valores.length === 0) return '';
		return valores
			.map((valor) => {
				const tipo = tiposPoblacionPriorizada.find((t) => t.value === valor || t.code === valor);
				return tipo?.label || valor;
			})
			.join(', ');
	};

	const COLUMNAS = 3;
	const camposCount = evento ? 8 : 0;
	const rellenoCount = (COLUMNAS - (camposCount % COLUMNAS)) % COLUMNAS;

	const franjasFiltradas = franjasHorarias.filter((franja) => {
		if (!evento?.franja_horaria_id) return false;

		const idsAsignados = Array.isArray(evento.franja_horaria_id)
			? evento.franja_horaria_id.map(String)
			: [String(evento.franja_horaria_id)];

		return (
			idsAsignados.includes(String(franja.id)) ||
			idsAsignados.includes(String((franja as any).code))
		);
	});
    const tieneFranjas = franjasFiltradas.length > 0;	
	return (
		<div className='p-4 shadow-4 rounded-3 mt-15' style={{ backgroundColor: '#FFFF' }}>
			<LoadingBackdrop loading={loading} />
			<div className='row mb-4' style={{ alignItems: 'center' }}>
				<div className='col-sm-12 d-flex align-items-center' style={{ gap: '15px' }}>
					<BackButton to={EVENTOS_LIST_PATH} />
					<h2 className='m-0'>Información del evento</h2>
				</div> 
			</div>

			{evento && (
				<div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '0 16px' }} className='mb-4'>
					<InfoField label='Código Evento' value={evento.codigo_evento} />
					<InfoField label='Nombre del Evento' value={evento.nombre_evento} />
					<InfoField label='Localidad' value={getLocalidadLabel()} />
					<InfoField label='Lugar' value={evento.lugar} />
					<InfoField label='Dirección' value={evento.direccion} />
					<InfoField label='Fecha Inicio del Evento' value={formatDateDisplay(evento.fecha_inicio_evento)} />
					<InfoField label='Fecha Fin del Evento' value={formatDateDisplay(evento.fecha_fin_evento)} />
					<InfoField label='Tipo de población priorizada' value={getTipoPoblacionLabel()} />
					{Array.from({ length: rellenoCount }).map((_, index) => (
						<FillerField key={`filler-${index}`} />
					))}
				</div>
			)}

			{!isReadOnly && isAdminRole() && (
			<Paper elevation={0} sx={{ p: 3, mb: 4, backgroundColor: '#F8FAFC', border: '1px solid #E2E8F0', borderRadius: 2 }}>
				<h4 className='mb-3' style={{ color: '#071324' }}>Prerregistro al Evento</h4>

					<Paper variant="outlined" sx={{ p: 2, mb: 3, backgroundColor: '#FFFFFF' }}>
						<Typography variant="subtitle2" sx={{ mb: 1, color: '#0A4396', fontWeight: 'bold' }}>
							Selección de Candidato
						</Typography>

						<Autocomplete
							options={candidates}
							loading={loadingCandidates}
							value={selectedCandidate}
							onChange={handleSelectCandidate}
							getOptionLabel={(option) =>
								`${option.tipo_doc} ${option.numero_doc} - ${option.primer_nome} ${option.primer_apelido}`
							}
							renderInput={(params) => (
								<TextField
									{...params}
									label="Buscar Candidato por Documento o Nombre"
									size="small"
									fullWidth
									InputProps={{
										...params.InputProps,
										endAdornment: (
											<>
												{loadingCandidates ? <CircularProgress color="inherit" size={20} /> : null}
												{params.InputProps.endAdornment}
											</>
										),
									}}
								/>
							)}
						/>
					</Paper>

				<Grid container spacing={2} sx={{ mb: 3 }}>
					<Grid item xs={12} sm={2}>
						<TextField label="Tipo Doc." size="small" fullWidth value={formData.tipo_doc} disabled />
					</Grid>
					<Grid item xs={12} sm={3}>
						<TextField label="Número Documento" size="small" fullWidth value={formData.numero_doc} disabled />
					</Grid>
					<Grid item xs={12} sm={3}>
						<TextField label="Primer Nombre" size="small" fullWidth value={formData.primer_nome} disabled />
					</Grid>
					<Grid item xs={12} sm={4}>
						<TextField label="Segundo Nombre" size="small" fullWidth value={formData.segundo_nome} disabled />
					</Grid>
					<Grid item xs={12} sm={6}>
						<TextField label="Primer Apellido" size="small" fullWidth value={formData.primer_apelido} disabled />
					</Grid>
					<Grid item xs={12} sm={6}>
						<TextField label="Segundo Apellido" size="small" fullWidth value={formData.segundo_apelido} disabled />
					</Grid>
				</Grid>

				<Typography variant='body2' sx={{ mb: 2 }}>
					Seleccione la franja horaria de su preferencia para confirmar la asistencia:
				</Typography>

				<FormControl fullWidth size='small' sx={{ maxWidth: 400, mb: 2 }}>
					<InputLabel id='franja-horaria-admin-label' shrink>
						Franja Horaria
					</InputLabel>
					<Select
						labelId='franja-horaria-admin-label'
						id='franja-horaria-admin-select'
						label='Franja Horaria'
						value={selectedFranja || ''}
						displayEmpty
						notched={true}
						disabled={!tieneFranjas || franjasHorarias.length === 0}
						onChange={(e) => setSelectedFranja(e.target.value)}
					>
						{franjasHorarias.length === 0 && (
							<MenuItem disabled value=''>
								Cargando catálogo de franjas...
							</MenuItem>
						)}

						{franjasHorarias.length > 0 && !tieneFranjas && (
							<MenuItem disabled value=''>
								No hay franja asignada a este evento
							</MenuItem>
						)}

						{franjasHorarias.length > 0 && tieneFranjas && (
							<MenuItem value=''>
								<em>Seleccione...</em>
							</MenuItem>
						)}

						{tieneFranjas &&
							franjasFiltradas.map((franja) => (
								<MenuItem key={franja.id} value={String(franja.id)}>
									{(franja as any).value || (franja as any).label || `Franja #${franja.id}`}
								</MenuItem>
							))}
					</Select>
				</FormControl>

				<div>
					<Button
						variant='contained'
						onClick={handlePrerregistrar}
						disabled={
							loadingPrerregistro ||
							!selectedFranja ||
							(isAdminRole() && !selectedCandidate)
						}
						sx={{ backgroundColor: '#0A4396', '&:hover': { backgroundColor: '#083373' } }}
					>
						{loadingPrerregistro ? 'Procesando...' : 'Confirmar Prerregistro'}
					</Button>
				</div>
			</Paper>
		)}

			{isCandidateRole() && isReadOnly === false && (
					<Paper elevation={0} sx={{ p: 3, mb: 4, backgroundColor: '#F8FAFC', border: '1px solid #E2E8F0', borderRadius: 2 }}>
						<h4 className='mb-3' style={{ color: '#1A365D' }}>Prerregistro al Evento</h4>
						<Typography variant='body2' sx={{ mb: 2 }}>
							Seleccione la franja horaria de su preferencia para confirmar la asistencia:
						</Typography>

						<FormControl fullWidth size='small' sx={{ maxWidth: 400, mb: 2 }}>
							<InputLabel id='franja-horaria-candidate-label' shrink>
								Franja Horaria
							</InputLabel>
							<Select
								labelId='franja-horaria-candidate-label'
								id='franja-horaria-candidate-select'
								label='Franja Horaria'
								value={selectedFranja || ''}
								displayEmpty
								notched={true}
								disabled={!tieneFranjas || franjasHorarias.length === 0}
								onChange={(e) => setSelectedFranja(e.target.value)}
							>
								{franjasHorarias.length === 0 && (
									<MenuItem disabled value=''>
										Cargando catálogo de franjas...
									</MenuItem>
								)}

								{franjasHorarias.length > 0 && !tieneFranjas && (
									<MenuItem disabled value=''>
										No hay franja asignada a este evento
									</MenuItem>
								)}

								{franjasHorarias.length > 0 && tieneFranjas && (
									<MenuItem value=''>
										<em>Seleccione...</em>
									</MenuItem>
								)}

								{tieneFranjas &&
									franjasFiltradas.map((franja) => (
										<MenuItem key={franja.id} value={String(franja.id)}>
											{(franja as any).value || (franja as any).label || `Franja #${franja.id}`}
										</MenuItem>
									))}
							</Select>
						</FormControl>

						<div>
							<Button
								variant='contained'
								onClick={handlePrerregistrar}
								disabled={loadingPrerregistro || !selectedFranja || isReadOnly}
								sx={{ backgroundColor: '#0A4396', '&:hover': { backgroundColor: '#083373' } }}
							>
								{loadingPrerregistro ? 'Procesando...' : 'Confirmar Prerregistro'}
							</Button>
						</div>
					</Paper>
				)}

			<h4 className='mt-4 mb-3'>Vacantes del evento</h4>

			<div
				style={{
					display: 'grid',
					gridTemplateColumns: 'repeat(4, 1fr)',
					gap: '10px',
					alignItems: 'end',
					marginBottom: 16,
				}}
			>
				<TextField
					fullWidth
					size='small'
					label='Filtro Código de vacante'
					value={codigoVacante}
					onChange={(e) => setCodigoVacante(e.target.value)}
				/>
				<TextField
					fullWidth
					size='small'
					label='Filtro Nombre de vacante'
					value={nombreVacante}
					onChange={(e) => setNombreVacante(e.target.value)}
				/>
				<TextField
					fullWidth
					size='small'
					type='number'
					label='Filtro Experiencia (meses)'
					value={experienciaFiltro}
					onChange={(e) => setExperienciaFiltro(e.target.value)}
				/>
				<FormControl fullWidth size='small'>
					<InputLabel id='nivel-estudio-filtro-label'>Nivel de estudio</InputLabel>
					<Select
						labelId='nivel-estudio-filtro-label'
						label='Nivel de estudio'
						value={nivelEstudioFiltro}
						onChange={(e) => setNivelEstudioFiltro(e.target.value)}
					>
						<MenuItem value=''>Todos</MenuItem>
						{nivelesEstudio.map((item) => (
							<MenuItem key={item.id} value={item.code}>
								{item.value}
							</MenuItem>
						))}
					</Select>
				</FormControl>
				<FormControl fullWidth size='small'>
					<InputLabel id='modalidad-trabajo-filtro-label'>Modalidad de trabajo</InputLabel>
					<Select
						labelId='modalidad-trabajo-filtro-label'
						label='Modalidad de trabajo'
						value={modalidadTrabajoFiltro}
						onChange={(e) => setModalidadTrabajoFiltro(e.target.value)}
					>
						<MenuItem value=''>Todas</MenuItem>
						{modalidadesTrabajo.map((item) => (
							<MenuItem key={item.id} value={item.code}>
								{item.value}
							</MenuItem>
						))}
					</Select>
				</FormControl>
				<FormControl fullWidth size='small'>
					<InputLabel id='tipo-contrato-filtro-label'>Tipo contrato</InputLabel>
					<Select
						labelId='tipo-contrato-filtro-label'
						label='Tipo contrato'
						value={tipoContratoFiltro}
						onChange={(e) => setTipoContratoFiltro(e.target.value)}
					>
						<MenuItem value=''>Todos</MenuItem>
						{tiposContrato.map((item) => (
							<MenuItem key={item.id} value={item.code}>
								{item.value}
							</MenuItem>
						))}
					</Select>
				</FormControl>
				<FormControl fullWidth size='small'>
					<InputLabel id='salario-desde-filtro-label'>Salario desde</InputLabel>
					<Select
						labelId='salario-desde-filtro-label'
						label='Salario desde'
						value={salarioDesdeFiltro}
						onChange={(e) => setSalarioDesdeFiltro(e.target.value)}
						MenuProps={salarioMenuProps}
					>
						<MenuItem value=''>Todos</MenuItem>
						{rangosSalarialesFiltrables.map((item) => (
							<MenuItem key={item.id} value={item.code}>
								{item.value}
							</MenuItem>
						))}
					</Select>
				</FormControl>
				<FormControl fullWidth size='small'>
					<InputLabel id='salario-hasta-filtro-label'>Salario hasta</InputLabel>
					<Select
						labelId='salario-hasta-filtro-label'
						label='Salario hasta'
						value={salarioHastaFiltro}
						onChange={(e) => setSalarioHastaFiltro(e.target.value)}
						MenuProps={salarioMenuProps}
					>
						<MenuItem value=''>Todos</MenuItem>
						{rangosSalarialesFiltrables.map((item) => (
							<MenuItem key={item.id} value={item.code}>
								{item.value}
							</MenuItem>
						))}
					</Select>
				</FormControl>
			</div>

			<Stack direction='row' spacing={2} justifyContent='flex-end' sx={{ mb: 2 }}>
				<Button variant='outlined' onClick={handleLimpiarFiltrosVacantes}>
					Limpiar filtros
				</Button>
				<Button variant='contained' onClick={handleBuscarVacantes}>
					Buscar
				</Button>
			</Stack>

			<div className={`${styleScss['table-limit']}`} style={{ maxWidth: '100%', overflowWrap: 'break-word', overflowY: 'hidden' }}>
				<Stack padding={2}>
					<TableContainer component={Paper} style={{ overflowY: 'visible', overflowWrap: 'break-word' }}>
						<Table style={{ overflowY: 'visible' }}>
							<TableHead className={`${styleScss['th-custom']}`}>
								<TableRow>
									<TableCell style={{ fontFamily: 'Poppins', fontSize: '16.25px', textAlign: 'center' }}><h4>Código vacante</h4></TableCell>
									<TableCell style={{ fontFamily: 'Poppins', fontSize: '16.25px', textAlign: 'center' }}><h4>Nombre vacante</h4></TableCell>
									<TableCell style={{ fontFamily: 'Poppins', fontSize: '16.25px', textAlign: 'center' }}><h4>Nivel de estudios</h4></TableCell>
									<TableCell style={{ fontFamily: 'Poppins', fontSize: '16.25px', textAlign: 'center' }}><h4>Experiencia</h4></TableCell>
									<TableCell style={{ fontFamily: 'Poppins', fontSize: '16.25px', textAlign: 'center' }}><h4>Modalidad de trabajo</h4></TableCell>
									<TableCell style={{ fontFamily: 'Poppins', fontSize: '16.25px', textAlign: 'center' }}><h4>Salario</h4></TableCell>
									<TableCell style={{ fontFamily: 'Poppins', fontSize: '16.25px', textAlign: 'center' }}><h4>Tipo de contrato</h4></TableCell>
								</TableRow>
							</TableHead>
							<TableBody>
								{vacantes.map((vacante) => (
									<TableRow key={vacante.id}>
										<TableCell style={{ fontFamily: 'Poppins', fontSize: '14.5px', textAlign: 'center' }}>{vacante.codigo_vacante}</TableCell>
										<TableCell style={{ fontFamily: 'Poppins', fontSize: '14.5px', textAlign: 'center' }}>{vacante.nombre_vacante}</TableCell>
										<TableCell style={{ fontFamily: 'Poppins', fontSize: '14.5px', textAlign: 'center' }}>{vacante.nivel_estudio}</TableCell>
										<TableCell style={{ fontFamily: 'Poppins', fontSize: '14.5px', textAlign: 'center' }}>{vacante.rango_experiencia}</TableCell>
										<TableCell style={{ fontFamily: 'Poppins', fontSize: '14.5px', textAlign: 'center' }}>{vacante.modalidad_trabajo}</TableCell>
										<TableCell style={{ fontFamily: 'Poppins', fontSize: '14.5px', textAlign: 'center' }}>{vacante.salario}</TableCell>
										<TableCell style={{ fontFamily: 'Poppins', fontSize: '14.5px', textAlign: 'center' }}>{vacante.tipo_contrato}</TableCell>
									</TableRow>
								))}
							</TableBody>
							{!loadingVacantes && buscadoVacantes && vacantes.length === 0 && (
								<tfoot>
									<TableRow>
										<TableCell colSpan={7}>
											<p className='text-center' style={{ width: '100%', textAlign: 'center' }}>
												No se encontraron registros
											</p>
										</TableCell>
									</TableRow>
								</tfoot>
							)}
						</Table>
					</TableContainer>
				</Stack>
			</div>

			<Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'right' }} open={open} onClose={() => setOpen(false)}>
				<Alert onClose={() => setOpen(false)} variant='filled' severity={alert ? 'success' : 'error'} sx={{ whiteSpace: 'pre-line' }}>
					{alert ? <AlertTitle>Éxito</AlertTitle> : <AlertTitle>Error</AlertTitle>}
					{alertMsg}
				</Alert>
			</Snackbar>
		</div>
	);
};

const AdminEventoInformacionWrapper = () => {
	return (
		<>
			<PageTitle breadcrumbs={[]}>Información del evento</PageTitle>
			<EventoInformacionPage />
		</>
	);
};

export { AdminEventoInformacionWrapper };


